import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts';
import { fetchRelatorioApontamentosIbsCbs } from '../api/RelatorioApontamentosIbsCbsApi';
import type { FiltroApontamentosIbsCbs } from '../types';

/** Só consulta com um filtro confirmado na tela (o botão "Consultar"), não a cada tecla. */
export function useRelatorioApontamentosIbsCbs(filtro: FiltroApontamentosIbsCbs | null) {
  const { user } = useAuth();
  const cnpjGestor = user?.cnpj;

  return useQuery({
    queryKey: ['relatorio-apontamentos-ibs-cbs', cnpjGestor, filtro],
    queryFn: () => fetchRelatorioApontamentosIbsCbs(filtro as FiltroApontamentosIbsCbs),
    staleTime: 60 * 1000,
    enabled: !!cnpjGestor && !!filtro,
  });
}
